module.exports = __webpack_public_path__ + "img/mapping.62bad851.png";